import { Button, Card, Text } from "../../../../components";
import Localization from "../../../../localization";
import { Images } from "../../../../assets";
import useViewModel from "../../viewModel";
import Settings from "./settings";
import Inactive from "./inactive";
import { Flex } from "antd";

const AlarmCentral = ({
  onEditClick = () => {},
  title = Localization.service.card_3_title,
  ...props
}) => {
  const { arc = {} } = useViewModel();
  return (
    <Card title={title} className="border-transparent" {...props}>
      <Flex gap={"1.5em"} className="flex-column-mobile">
        <img
          src={Images.westraSecurity}
          style={{ width: "30%", minWidth: "11.9rem" }}
        />
        <div>
          <Text
            level={4}
            weight={700}
            children={Localization.service.alarm_operator_title}
          />
          <Text
            weight={500}
            className="m-7-t"
            color={arc.confirmed ? "success" : "primary"}
            children={`${Localization.general.status}: ${
              arc.confirmed
                ? Localization.general.good
                : Localization.service.alarm_operator_status_error
            }`}
          />
        </div>
      </Flex>
      <Button
        ghost
        type="primary"
        onClick={onEditClick}
        className="m-30-t"
        title={Localization.service.card_3_btn}
      />
    </Card>
  );
};

AlarmCentral.Inactive = Inactive;
AlarmCentral.Settings = Settings;

export default AlarmCentral;
